import type { ProjectInfoButtonProps } from "./project-info-button.type";
import type { ButtonProps } from "antd";

import InfoButton from "@/components/Header/Button/InfoButton";
import Info from "@/features/Projects/Info";
import { useSidePanel } from "@/modules/side-panel";

export const ProjectInfoButton = ({
  project,
  type,
  onClick,
  ...buttonProps
}: ProjectInfoButtonProps) => {
  const { openSidePanel } = useSidePanel();

  const onButtonClick: ButtonProps["onClick"] = (e) => {
    openSidePanel({
      title: project.name,
      component: <Info project={project} />,
    });
    onClick?.(e);
  };

  return <InfoButton onClick={onButtonClick} type={type} {...buttonProps} />;
};
